import React, { useState } from "react";
import { motion } from "framer-motion";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { IoChevronDown } from "react-icons/io5";
import CitiesPopup from "../../../styles/selectedcity.css";
import SelectAreaPopup from "components/popup/selectAreaPopup";
import { LocalStorageUtils } from "utils/localstorage.utils";

const SelectArea = () => {
  const [showPopup, setShowPopup] = useState(false);
  const areaName = LocalStorageUtils.get(
    LocalStorageUtils.LOCAL_STORAGE_KEY.AREA_NAME
  );
  return (
    <>
      {areaName ? (
        <div className="home_city-container">
          <motion.div
            className="home_city-display"
            whileTap={{ scale: 0.95 }}
            onClick={() => setShowPopup(true)}
          >
            <HiOutlineLocationMarker className="home_city-icon" />
            <span className="home_city-name">{areaName}</span>
            <IoChevronDown className="home_city-chevron" />
          </motion.div>

          {showPopup && <SelectAreaPopup onClose={() => setShowPopup(false)} />}
        </div>
      ) : (
        <> </>
      )}
    </>
  );
};

export default SelectArea;
